<template>
	<div>
		<router-view/>	
	</div>
</template>
<script>
export default {
	name: 'Login',
	data() {
		return {
		
		}
    },
	mounted() {
	},
	methods: {
		
	}
}
</script>

<style lang="scss">
	@import "assets/css/reset.css";
	@import "assets/css/common.scss";
</style>
